<template>
  <div v-if="!state.loading">
    <div class="pgehd">
        <h2>{{state.title}}</h2>
    </div>
    
    <PrimeDataTable
        :value="list"
        :rows="10"
        responsiveLayout="scroll"
        stripedRows>

        <PrimeColumn field="sn" header="sn" />
        <PrimeColumn field="name" header="Name" />
        <PrimeColumn header="Options">
            <template #body="slotProps">
                <div class="flex gap-2">
                    <PrimeButton
                        v-if="user.persona != 'Student'"
                        label="Questions"
                        icon="pi pi-bars"
                        class="p-button-rounded p-button-text"
                        @click="chooseGrade(slotProps.data)"
                    />
                    <PrimeButton
                        v-if="user.persona == 'Student' && state.status"
                        label="Write"
                        icon="pi pi-bars"
                        class="p-button-rounded p-button-text"
                        @click="write(slotProps.data)"
                    />
                </div>
            </template>
        </PrimeColumn>
    </PrimeDataTable>
  </div>
  <div v-else class="loader">
    <img src="@/assets/img/ajldr.gif" />
  </div>
</template>
<script>
import call from "../composables/call.js";
import { urls } from "../assets/js/urls.js";
import { onMounted, reactive, ref, computed} from 'vue';
import { useRouter,useRoute } from "vue-router";
import { useStore } from 'vuex';

export default {
    name:"TestManager",
    setup(){
        const router = useRouter();
        const route = useRoute();
        const store= useStore();
        const user = computed(() => store.state.User.user);
        const id = computed(() => route.params.id)
        const state=reactive({loading:true,createModal:false,title:"Subjects",
            submitting:false,error:[],success:false,status:false
        })
        const list = ref([])
        const globalFilter=ref("")

        function setTable(d){
            if (!Array.isArray(d)) {
                list.value = Object.values(d)
            } else {
                list.value = d
            }
        }

        onMounted(() => {
            var data;
            if(user.value.persona != "Student"){
                data={getSubjectList:""}
            }else{
                data={getStudentGroup:""}
            }
            data.t_id=id.value;
            call({
                url:urls.subject,
                data:data,
                success:(res)=>{
                    state.loading=false
                    if(res.status){
                        setTable(res.msg.list)
                        state.status=res.msg.active;
                    }else{
                        alert(res.msg);
                    }
                }
            })
        });

        function chooseGrade(row){
            router.push({ name: 'testgrade', params: { id: id.value, sub: row.id } });
        }

        function write(row){
            router.push({ name: 'writetest', params: { id: id.value, group: row.id } });
        }
        
        return {list,globalFilter, state,chooseGrade,user, write}
    }
}
</script>